<template>
    <div :class="{ 'bg-stack-background p-3': padded }">
        <LinksSegment
            v-if="segment.type === 'links'"
            :links="segment.links"
            :variant="segment.style"
            :link-style="linkStyle"
            :preview-only="!interactive"
            :open-in-new-tab="interactive"
        />
        <BannersSegment
            v-else-if="segment.type === 'banners'"
            :links="segment.links"
            :variant="segment.style"
            :is-desktop="isDesktop"
            :preview-only="!interactive"
            :open-in-new-tab="interactive"
        />
        <ProductsCarouselSegment
            v-else-if="segment.type === 'productsCarousel'"
            :products="segment.products"
            :variant="segment.style"
            :stack="stack"
            :dark="dark"
            :is-desktop="isDesktop"
            :preview-only="!interactive"
            :open-in-new-tab="interactive"
        />
        <TextSegment
            v-else-if="segment.type === 'text'"
            :variant="segment.style"
            :title="segment.title"
            :text="segment.text"
            :image-url="textImageUrl"
            :image-alt="segment.title"
            :font-family="segment.fontFamily"
            :is-desktop="isDesktop"
            :preview-only="!interactive"
        />
        <TestimonialsSegment
            v-else-if="segment.type === 'testimonials'"
            :items="testimonialsItems"
            :preview-only="!interactive"
        />
        <SocialFeedSegment
            v-else-if="
                segment.type === 'media' && segment.displayMode === 'multiple'
            "
            :media-type="segment.mediaType"
            :items="segment.items"
            :preview-only="!interactive"
        />
        <MediaSegment
            v-else-if="segment.type === 'media'"
            :key="segment.link"
            :media-type="segment.mediaType"
            :link="segment.link"
        />
        <div
            v-else-if="segment.type === 'markdown'"
            class="catalog-markdown"
            v-html="markdownHtml"
        ></div>
        <DividerSegment
            v-else-if="segment.type === 'divider'"
            :segment="segment"
        />
    </div>
</template>

<script>
import { getButtonStyle } from "@/common/lib/button-style";
import { renderMarkdown } from "@/common/markdown/renderMarkdown";

import BannersSegment from "@/components/catalog/BannersSegment.vue";
import DividerSegment from "@/components/catalog/DividerSegment.vue";
import LinksSegment from "@/components/catalog/LinksSegment.vue";
import MediaSegment from "@/components/catalog/MediaSegment.vue";
import ProductsCarouselSegment from "@/components/catalog/ProductsCarouselSegment.vue";
import SocialFeedSegment from "@/components/catalog/SocialFeedSegment.vue";
import TestimonialsSegment from "@/components/catalog/TestimonialsSegment.vue";
import TextSegment from "@/components/catalog/TextSegment.vue";

export default {
    name: "SegmentPreview",
    components: {
        LinksSegment,
        BannersSegment,
        ProductsCarouselSegment,
        TextSegment,
        TestimonialsSegment,
        MediaSegment,
        SocialFeedSegment,
        DividerSegment
    },
    props: {
        segment: {
            type: Object,
            required: true
        },
        stack: {
            type: Object,
            required: true
        },
        dark: {
            type: Boolean,
            default: false
        },
        isDesktop: {
            type: Boolean,
            default: true
        },
        // Dentro de CatalogPreviewFrame el marco ya pone fondo y espaciado.
        padded: {
            type: Boolean,
            default: true
        },
        // Links clickeables (en pestaña nueva), como en la vista previa del
        // catálogo; en la lista de bloques son solo de muestra.
        interactive: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        linkStyle() {
            return getButtonStyle("rounded", this.stack);
        },
        textImageUrl() {
            return (
                (this.segment.image && this.segment.image.url) ||
                this.segment.imageUrl ||
                null
            );
        },
        testimonialsItems() {
            return (this.segment.items || []).map((item) => ({
                ...item,
                imageUrl:
                    (item.image && item.image.url) || item.imageUrl || null
            }));
        },
        markdownHtml() {
            return renderMarkdown(this.segment.content || "");
        }
    }
};
</script>
